// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__lVCGF","box":"WorkspacesBox_box__PBlru","node":"WorkspacesBox_node__1kaJA"};